"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var live_statuses_1 = require("@wix/wix-vod-constants/dist/common/live-statuses");
exports.mapMediaInfoToLiveVideoStatus = function (mediaInfo, itemType) {
    var _a, _b, _c;
    var status = (_c = (_b = (_a = mediaInfo) === null || _a === void 0 ? void 0 : _a.fileOutput) === null || _b === void 0 ? void 0 : _b.video[0]) === null || _c === void 0 ? void 0 : _c.status;
    var isLiveVideo = itemType === item_type_1.ItemType.ItemLive;
    return isLiveVideo ? live_statuses_1.LIVE_VIDEO_STATUS[status] : undefined;
};
//# sourceMappingURL=mapMediaInfoToLiveStatus.js.map